import { Divider, Grid } from '@mui/material'
import { AppBox, AppButton, AppTypography } from 'components'
import { FC } from 'react'
import { CrmContactImportModel } from 'sdk'
import * as XLSX from 'xlsx'

interface Props {
  goodContacts: CrmContactImportModel[]
  uniqueCompanies: string[]
  totalRecords: any[]
  badContacts: any[]
  uploadContacts: () => void
}

export const ImportContactWizardStepFourSummary: FC<Props> = ({
  goodContacts,
  uniqueCompanies,
  totalRecords,
  badContacts,
  uploadContacts,
}) => {
  const downloadBadRecords = () => {
    const records = badContacts
    const data = XLSX.utils.json_to_sheet(records)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, data, 'data')
    XLSX.writeFile(wb, 'Invalid-Data.xlsx')
  }
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <AppBox backgroundColor="white" padding={2} borderRadius={3} border={1} borderColor={'grey.300'}>
          <AppTypography color={'grey.500'} fontSize={14} fontWeight={400}>
            Please review the following information about the records that you have chosen to import into your CRM. Be
            sure to download your invalid records so that they can be corrected and imported at a later time. After
            clicking the Import button simply click Close and we’ll import your valid records in the background as you
            work on other tasks.
          </AppTypography>
        </AppBox>
      </Grid>
      <Grid item xs={12}>
        <AppBox backgroundColor="white" padding={2} borderRadius={3} border={1} borderColor={'grey.300'}>
          <AppTypography fontSize={14} fontWeight={500}>
            Total Contacts Uploaded : {totalRecords.length.toLocaleString()}
          </AppTypography>
        </AppBox>
      </Grid>
      <Grid item xs={6} display={'inline-flex'}>
        <AppBox
          backgroundColor="white"
          paddingY={2}
          paddingX={4}
          paddingBottom={4}
          borderRadius={3}
          border={1}
          borderColor={'grey.300'}
        >
          <AppTypography fontSize={14} fontWeight={500}>
            Invalid Records
          </AppTypography>
          <AppTypography fontSize={14} color={'grey.500'} paddingTop={1}>
            Download your list of invalid records and we’ll include the reason why they were considered invalid. After
            correcting the issues, you can attempt to import them into your CRM at later date.
          </AppTypography>
          <AppBox textAlign={'center'}>
            <AppBox paddingTop={6} paddingBottom={4}>
              <AppTypography fontSize={16}>Total invalid Records:</AppTypography>
              <AppTypography fontSize={16} color={'red'}>
                {badContacts.length.toLocaleString()}
              </AppTypography>
            </AppBox>
            <AppButton
              variant="outlined"
              sidePaddings={4}
              onClick={downloadBadRecords}
              disabled={badContacts.length === 0}
            >
              Download
            </AppButton>
          </AppBox>
        </AppBox>
      </Grid>
      <Grid item xs={6} display={'inline-flex'}>
        <AppBox
          backgroundColor="white"
          paddingY={2}
          paddingX={4}
          paddingBottom={4}
          borderRadius={3}
          border={1}
          borderColor={'grey.300'}
        >
          <AppBox paddingBottom={1}>
            <AppTypography fontSize={14} fontWeight={500}>
              Valid Records
            </AppTypography>
          </AppBox>
          <AppTypography fontSize={14} color={'grey.500'} paddingTop={1}>
            After clicking the Import button, we’ll quietly add your records in the background so you can work on other
            tasks. Depending on the size of your import, you should see your records display in your CRM within a minute
            or two.
          </AppTypography>
          <Grid container paddingTop={2}>
            <Grid item xs={6} textAlign={'center'}>
              <AppTypography fontSize={16}>Total Unique Contacts:</AppTypography>
              <AppTypography fontSize={16} color={'blue'}>
                {goodContacts.length.toLocaleString()}
              </AppTypography>
            </Grid>
            <Grid item xs={6} textAlign={'center'} borderLeft={1} borderColor={'grey.300'}>
              <AppTypography fontSize={16}>Total Unique Companies:</AppTypography>
              <AppTypography fontSize={16} color={'blue'}>
                {uniqueCompanies.length.toLocaleString()}
              </AppTypography>
            </Grid>
          </Grid>
          <AppBox textAlign={'center'} paddingTop={4}>
            <AppButton
              variant="contained"
              sidePaddings={6}
              size="large"
              disabled={goodContacts.length === 0}
              onClick={() => uploadContacts()}
              prefixIcon="lets-icons:import-fill"
              style={{ color: 'white', background: 'green' }}
            >
              Import
            </AppButton>
          </AppBox>
        </AppBox>
      </Grid>
    </Grid>
  )
}
